<template>
  <van-button block :type="buttontype" @click="Save">{{buttonname}}</van-button>
</template>

<script>
  export default {
    name: 'SaveButton',
    data() {
      return {
        fullscreenLoading: false
      }
    },
    props: {
      url: {
        type: String
      },
      back: {
        type: String,
        defalut: ''
      },
      buttonname: {
        type: String,
        default: '保存'
      },
      buttontype: {
        type: String,
        default: 'info'
      },
      editMode: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      Save: function() {
        var form = null
        var parent = this.$parent
        while (form == null) {
          form = parent.form
          if (form != null) {
            break
          } else {
            parent = parent.$parent
          }
        }
        if (form.Save != null) {
          form.Save()
        } else {
          console.log(parent.$refs['form']);
          parent.$refs['form'].validate()
            .then(() => {
              this.fullscreenLoading = true
              //编辑模式,put提交,新增模式post提交
              let requestType = "post"
              console.log(requestType);
              if (this.editMode) {
                requestType = "put"
              }
              //统一设置路径地址
              if (!form.hasOwnProperty("filePath")) {
                form["filePath"] = parent.$options.name
              }

              // 提交操作,确认后再提交
              if (form.hasOwnProperty("saveType") && form.saveType == 1) {
                this.$dialog.confirm({
                    title: '提交操作',
                    message: '确认提交吗，提交后无法修改',
                  })
                  .then(() => {

                    // 提交数据
                    this.FormSubmit(requestType, form)
                  })
              } else {
                // 提交数据
                this.FormSubmit(requestType, form)
              }




            })
            .catch((e) => {
              console.log(e);
              // on cancel
              console.log('error submit!!')
              return false;
            });
        }
      },
      // 提交表单事件
      FormSubmit(requestType, form) {
        // 后台请求
        this.$http[requestType](this.url, form)
          .then(res => {

            if (res.data.Code === 0) {
              let messageShow = "保存成功"
              if (form.hasOwnProperty("saveType") && form.saveType == 1) {
                messageShow = "提交成功"
              }
              this.$dialog.alert({
                message: messageShow
              })
              if (this.back != "0") {
                this.$router.push('/main' + this.back)
              } else {
                this.$emit('saveSucess')
              }
            }else{
              this.$dialog.alert({
                message: res.data.Error
              })
            }
            this.fullscreenLoading = false
          })
          .catch(err => {
            console.log(err)
            this.$dialog.alert({
              message: "操作失败"
            })
            this.fullscreenLoading = false
          })
      }
    },

  }
</script>

<style>
</style>
